/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAddress } from './customer_address'
/**
 * Запрос на создание контрагента
 */
export type CustomerCreateRequest = {
  /**
   * Источник данных (User - поля с адресом заполнил пользователь, Auto - поля с адресом заполнены без участия пользователя)
   */
  dataSource?: CustomerCreateRequest.dataSource
  /**
   * ИНН
   */
  inn: string
  /**
   * Наименование
   */
  name: string
  /**
   * КПП (обязательное поле для юр.лиц не ИП)
   */
  kpp?: string
  /**
   * Юридический адрес (обязательное поле при dataSource = Auto)
   */
  legalAddress?: string
  /**
   * Юридический адрес (обязательное поле при dataSource = User)
   */
  address?: CustomerAddress
}
export namespace CustomerCreateRequest {
  /**
   * Источник данных (User - поля с адресом заполнил пользователь, Auto - поля с адресом заполнены без участия пользователя)
   */
  export enum dataSource {
    AUTO = 'auto',
    USER = 'user'
  }
}
